import React, { useEffect, useState } from "react";
import { APPLICATION_NAME, removeEmptyObjectKey, SOCKET_CHANNEL, SOCKET_URL, SOCKET_TRANSPORTS } from "src/_config";
import { RodeoTvImageComponent } from "src/components/tv-image/tv-image-page";
import useSocket from "src/_common/hooks/useSocket";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useParams } from "react-router";

export default function RodeoTvImageContainer() {
  const eventApi = useEventApi();
  const { gameId } = useParams<{ gameId?: string }>();

  const [_site, setSite] = useState<string>("scavenger");
  const [globalTvData, setGlobalTvData] = useState<Record<string, unknown> | null>(null);
  const [socketChannel, setSocketChannel] = useState<string | null>(null);
  const [rodeoEventId, setRodeoEventId] = useState<string | null>(null);

  const getTvImageDetails = (screen1: string, type: string | null) => {
    // let reId = localStorage.getItem("rodeoEventId");
    const params = {
      screen1,
      type,
    };
    eventApi.callTvImageDetails(
      removeEmptyObjectKey(params),
      (message: string, resp: unknown) => {
        console.log({ resp });
        // if (!reId) {
        //   localStorage.setItem("rodeoEventId", resp?.rodeo_event_dtls?.id);
        // }
        if (resp && typeof resp === "object" && "rodeo_event_game_info" in resp) {
          const respData = resp as {
            rodeo_event_game_info?: { rp_is_fan_favrouite?: number };
            rodeo_event_dtls?: { id?: string | number };
          };
          if (respData.rodeo_event_game_info?.rp_is_fan_favrouite == 1) {
            // setSite("fan-favorite");
          } else {
            setSite("scavenger");
            if (respData.rodeo_event_dtls?.id !== undefined) {
              setRodeoEventId(String(respData.rodeo_event_dtls.id));
            }
          }
        } else {
          // setSite("fan-favorite");
          setSite("scavenger");
        }
      },
      (message: string) => {
        console.error(`Error at API Access => ${message}`);
      },
    );
  };

  const setSiteDataChannelValues = (site: string, data: Record<string, unknown>, channel: string) => {
    //setSite(site);
    setGlobalTvData(data);
    setSocketChannel(channel);
  };

  useEffect(() => {
    if (gameId) {
      getTvImageDetails(gameId, null);
    }
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : TV Leaderboard`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true, // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    Object.values(SOCKET_CHANNEL).forEach((item: string) =>
      socket.on(item, (data: Record<string, unknown>) => {
        console.log(data);
        setSiteDataChannelValues("scavenger", data, item);
      }),
    );

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return (
    <React.Fragment>
      <RodeoTvImageComponent
        globalTvData={globalTvData}
        socketChannel={socketChannel}
        setGlobalTvData={setGlobalTvData}
        setSocketChannel={setSocketChannel}
        rodeoEventId={rodeoEventId}
      />
    </React.Fragment>
  );
}
